module.exports = __webpack_public_path__ + "img/tan.fb7c7956.png";